import { getApps, initializeApp } from 'firebase/app'
import {
  connectAuthEmulator,
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from 'firebase/auth'

import {
  firebaseApiKey,
  firebaseAuthDomain,
  firebaseEmulating,
  firebaseEmulatorHost,
  firebaseProjectId,
} from '@admin/config'

const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId,
}

// Initialize Firebase
const apps = getApps()
const firebaseApp = apps.length === 0 ? initializeApp(firebaseConfig) : apps[0]

export const authApp = getAuth(firebaseApp)
if (process.env.NODE_ENV !== 'production' && firebaseEmulating) {
  connectAuthEmulator(authApp, firebaseEmulatorHost)
}

export const googleLogin = async () => {
  const provider = new GoogleAuthProvider()
  // 工数かかるから後で
  // https://firebase.google.com/docs/auth/web/redirect-best-practices?hl=ja
  // signInWithRedirect(authApp, provider)
  await signInWithPopup(authApp, provider)
}

export const getToken = async () => {
  const { currentUser } = authApp
  if (currentUser) {
    const token = await currentUser.getIdToken()
    return token
  }
  return null
}

export const firebaseLogout = async () => {
  await signOut(authApp)
}
